var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.62,
    height: 16.62,
    viewBox: "0 0 16.62 16.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "copy",
    d: "M14.672,16.62H5.843A1.95,1.95,0,0,1,3.9,14.672V5.843A1.95,1.95,0,0,1,5.843,3.9h8.829A1.95,1.95,0,0,1,16.62,5.843v8.829A1.95,1.95,0,0,1,14.672,16.62ZM5.843,5.194a.65.65,0,0,0-.649.649v8.829a.65.65,0,0,0,.649.649h8.829a.65.65,0,0,0,.649-.649V5.843a.65.65,0,0,0-.649-.649ZM2.6,11.426H1.948a.65.65,0,0,1-.649-.649V1.948A.65.65,0,0,1,1.948,1.3h8.829a.65.65,0,0,1,.649.649v.617h1.3V1.948A1.95,1.95,0,0,0,10.777,0H1.948A1.95,1.95,0,0,0,0,1.948v8.829a1.95,1.95,0,0,0,1.948,1.948H2.6Zm0,0",
    fill: "#2c67a7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.b598ac95cfadeaefe1bf2f9c51cf4a74.svg";
export { ForwardRef as ReactComponent };